import { render, staticRenderFns } from "./GroupAvatar.vue?vue&type=template&id=5e2fce40&scoped=true"
import script from "./GroupAvatar.vue?vue&type=script&lang=js"
export * from "./GroupAvatar.vue?vue&type=script&lang=js"
import style0 from "./GroupAvatar.vue?vue&type=style&index=0&id=5e2fce40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2fce40",
  null
  
)

export default component.exports